import React, { RefObject, useRef } from 'react'
import { useMatch, useResolvedPath } from 'react-router-dom'
import { urlService, navigationService } from '../../../services'
import { HashLink } from 'react-router-hash-link'
import { Dropdown } from '@vista-digital/occ-ui'
import { closeBurgerMenu } from '.'
import { useCollapsibleNavItems } from '../hooks/useCollapsibleNavItems'

interface NavigationProps {
    headerContainer: RefObject<HTMLDivElement>
}

const ZERO_WIDTH_SPACE = '\u200B'

export const Navigation: React.FC<NavigationProps> = props => {
    const navContainer = useRef<HTMLDivElement>(null)
    const moreButton = useRef<HTMLDivElement>(null)

    const { navItems, moreDropdownOptions } = useCollapsibleNavItems(navContainer, moreButton)

    const handleDropdownSelection = (url: string) => {
        const parts = url.split(ZERO_WIDTH_SPACE)
        navigationService.goTo(parts[0], parts[1] === '_blank')
    }

    const matches = (url: string) => {
        // Never have jump links show as selected
        if (url.includes('#')) {
            return false
        }

        let resolved = useResolvedPath(url)
        let match = useMatch({ path: resolved.pathname, end: url == '/' ? true : false })

        return match
    }

    return (
        <nav className="header-nav" ref={navContainer}>
            {navItems.map((link, index) => {
                const isCollapsedClass = link.isCollapsed ? 'is-collapsed' : ''

                return (
                    <div
                        className={`header-nav-link-container ${isCollapsedClass} ${
                            matches(link.url) ? 'selected' : ''
                        }`}
                        key={'nav-link-' + index}
                        ref={link.ref}
                    >
                        {urlService.isRouted(link.url) && link.target !== '_blank' ? (
                            <HashLink onClick={closeBurgerMenu} to={link.url}>
                                {link.name}
                            </HashLink>
                        ) : (
                            <a target={link.target} href={link.url}>
                                {link.name}
                            </a>
                        )}
                    </div>
                )
            })}

            {moreDropdownOptions.length > 0 && (
                <div className="nav-more v-dropdown-nav-more" ref={moreButton}>
                    <Dropdown
                        buttonIconName="arrowDown"
                        enableSearch={false}
                        placeholder="More"
                        options={moreDropdownOptions}
                        onChangeValue={handleDropdownSelection}
                    />
                </div>
            )}
        </nav>
    )
}

export default Navigation
